import * as React from 'react';

import { SearchIcon, CancelIcon, TextInput } from '@circleci/compass';
import { SearchBoxProvided } from 'react-instantsearch-core';
import { connectSearchBox } from 'react-instantsearch-dom';

import { LibContext, Action } from '~/contexts/LibContext';
import { styled } from '~/styled';

import searchTranslations from './search-translations.json';

const Form = styled.form(`
  position: relative;
`);

const StyledTextInput = styled(TextInput)(({ theme }) => {
  return `
    width: 100%;
    border-color: ${theme.colors.n90};
    border-style: solid;
    border-width: 0px;
    border-radius: ${theme.space.space4};
    padding: 0 ${theme.space.space32};
    background-color: ${theme.colors.white};
    color: ${theme.colors.n900};
    font-size: ${theme.fontSizes.fontsize16};
    line-height: ${theme.lineHeights.lineheight24};

    @media (min-width: ${theme.breakpoints[2]}) {
      padding: ${theme.space.space8} ${theme.space.space48};
      border-width: 1px;
    }

    ::placeholder {
      color: ${theme.colors.n400};
    }

    outline: 0;
  `;
});

const IconZone = styled.div(`
  height: 100%;
  position: absolute;
  cursor: pointer;
`);

const SearchIconZone = styled(IconZone)(({ theme }) => {
  return `
    display: flex;
    align-items: center;
    left: 0;

    @media (min-width: ${theme.breakpoints[2]}) {
      padding-left: ${theme.space.space16};
    }
  `;
});

const CancelIconZone = styled(IconZone)<{ queryLength: number }>(({
  theme,
  queryLength,
}) => {
  return `
    display: flex;
    align-items: center;
    right: 0;

    // on desktop we want to hide cancel icon if no query
    @media (min-width: ${theme.breakpoints[2]}) {
      display: ${queryLength >= 1 ? 'flex' : 'none'};
      padding-right: ${theme.space.space12};
    }
  `;
});

export const SearchBar = connectSearchBox(
  ({
    onCancel,
    currentRefinement,
    refine,
  }: SearchBoxProvided & { onCancel: () => void }) => {
    const inputRef = React.useRef<HTMLInputElement>(null);
    const { notifyTrackingFired } = React.useContext(LibContext);
    const locale = 'en';

    return (
      <Form
        noValidate
        action=""
        role="search"
        onClick={() => {
          return (
            notifyTrackingFired &&
            notifyTrackingFired('search-box', Action.clicked)
          );
        }}
      >
        <SearchIconZone
          onClick={() => {
            return inputRef.current?.focus();
          }}
        >
          <SearchIcon size={24} />
        </SearchIconZone>

        <CancelIconZone
          queryLength={currentRefinement.length}
          onClick={() => {
            refine();
            if (onCancel) {
              onCancel();
            }
          }}
          data-testid="search-documentation-reset"
        >
          <CancelIcon size={28} />
        </CancelIconZone>

        <StyledTextInput
          data-testid="search-documentation-inputbox"
          placeholder={searchTranslations[locale].searchBarPlaceholder}
          value={currentRefinement}
          onKeyPress={(e) => {
            e.key === 'Enter' && e.preventDefault();
          }}
          onChange={(event) => {
            return refine(event.currentTarget.value);
          }}
          ref={inputRef}
        />
      </Form>
    );
  },
);
